export default __webpack_public_path__ + "static/media/Footpad's Gloves of the Smoldering Throne.9dd985e5.jpg";